import { Component } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ConfigurationService } from '../../providers/configuration/configuration.service';

@Component({
  selector: 'app-nominee-opt-out-popup',
  templateUrl: './nominee-opt-out-popup.component.html',
  styleUrls: ['./nominee-opt-out-popup.component.scss']
})
export class NomineeOptOutPopupComponent {

  address: string = '';
  optOutUrl: string = '';

  constructor(
    public dialogRef: MatDialogRef<NomineeOptOutPopupComponent>,
    private _dialog: MatDialog,
    private configurationService: ConfigurationService,
  ) {
  const firebaseAddress = this.configurationService.remoteConfigCacheObj['NomineeConfig']?.address;
  this.address = firebaseAddress.replace(/\\n/g, '<br>');
  this.optOutUrl = this.configurationService.remoteConfigCacheObj['NomineeConfig']?.optOutUrl;
  }

  
  downloadForm() {
    window.open(this.optOutUrl, '_blank');
    this.closePopup();
  }

  closePopup() {
    this.dialogRef.close();
  }
}
